import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isOfflineModeActive: false,
    offlineModeUserIdentity: [],
    uploadQueue: [],
    localUserOfflineModeIdentity: null, // This will hold the identity of the local user in offline mode
    offlineModeUploadedImageCount: 0,
    isOfflineModeInProgress: false,
};

const offlineModeReducerSlice = createSlice({
    name: "offlineModeReducer",
    initialState,
    reducers: {
        setIsOfflineModeActive(state, action) {
            state.isOfflineModeActive = action.payload;
        },
        setOfflineModeUserIdentity(state, action) {
            state.offlineModeUserIdentity = action.payload;
        },
        setUploadQueue(state, action) {
            state.uploadQueue = action.payload;
        },
        setLocalUserOfflineModeIdentity(state, action) {
            state.localUserOfflineModeIdentity = action.payload;
        },
        setOfflineModeUploadedImageCount(state, action) {
            state.offlineModeUploadedImageCount = action.payload;
        },
        setIsOfflineModeInProgress(state, action) {
            state.isOfflineModeInProgress = action.payload;
        },
        resetOfflineModeReducer() {
            return initialState;
        },
    },
});

export const {
    setIsOfflineModeActive,
    setOfflineModeUserIdentity,
    setUploadQueue,
    setLocalUserOfflineModeIdentity,
    setOfflineModeUploadedImageCount,
    setIsOfflineModeInProgress,
    resetOfflineModeReducer,
} = offlineModeReducerSlice.actions;
export default offlineModeReducerSlice.reducer;
